<!-- 园区公告界面 -->
<template>
  <div class="park-notice-box">
    <div class="left-box">
      <el-scrollbar style="height: 100%">
        <!-- 头部区域 -->
        <h3 class="title-box">
          公告分类
          <img :src="imgUrl" style="width: 22px; height: 22px; position: absolute; right: 15px; cursor: pointer;"
            @click="addNoticeClassify" />
        </h3>
        <!-- 分类内容区域-->
        <div class="content-box">
          <div v-for="(item, index) in noticeClassifyArr" :key="index" :class="[
            index != noticeClassifyArr.length - 1
              ? 'content-border-item'
              : 'content-item',
            item.selected ? 'content-selected-item' : '',
          ]" @click="selectedNoticeClassifyItem(item)">
            <div>{{ item.label }}</div>
            <!-- 修改、删除按钮 -->
            <div>
              <img :src="editImgUrl" style="width: 18px; height: 18px; cursor: pointer"
                @click="editNoticeClassify(item)" />
              <img :src="deleteImgUrl" style="
                  width: 18px;
                  height: 18px;
                  cursor: pointer;
                  margin: 0 10px;
                " @click="deleteNoticeClassify(item)" />
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="right-box access-record-container">
      <!--主页面 -->
      <div class="flex-row" style="height: 100%">
        <div class="flex-auto flex-valign" style="overflow: hidden">
          <!-- 右侧表格 -->
          <div class="section-main_table">
            <ioc-table ref="accessTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
              @search-change="searchResult" @search-reset="resetQuery" @current-change="selectPage"
              @size-change="changeSize" @selection-change="handleSelectionChange">
              <!-- 表格搜索条件 自定义 -->
              <!-- 状态-->
              <!-- <template slot="search_status">
                <div>
                  <el-select v-model="searchParams.status" placeholder="请选择">
                    <el-option v-for="item in noticeStatusOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </template> -->
              <!-- 发布时间 -->
              <template slot="search_createTime">
                <div>
                  <el-date-picker type="datetime" placeholder="请选择开始时间" v-model="searchParams.startTime"
                    default-time="00:00:00" style="width: 182px"></el-date-picker>
                  <span style="padding: 0 5px">至</span>
                  <el-date-picker type="datetime" placeholder="请选择结束时间" v-model="searchParams.endTime"
                    default-time="23:59:59" style="width: 182px"></el-date-picker>
                </div>
              </template>
              <!-- 上方按钮 -->
              <template slot="menuLeft">
                <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus"
                  @click="handleAddNotice">
                  新增
                </el-button>
                <el-button size="small" icon="el-icon-delete" class="iss-operation-button" @click="handelDelNotice"
                  :disabled="!checkedNoticeIds.length ? true : false">
                  批量删除
                </el-button>
              </template>
              <!-- 自定义操作列 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="iconfont icon-Detail"
                    @click="handleView(scope.row, scope.index)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw"
                  v-if="scope.row.status == 1">
                  <el-button type="text" icon="iconfont icon-xiugai"
                    @click="handleEditNotice(scope.row, scope.index)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="发布" placement="top" popper-class="tooltip-draw"
                  v-if="scope.row.status == 1">
                  <el-button type="text" icon="iconfont iconjiantou-copy-copy1"
                    @click="handlePublish(scope.row, scope.index)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="iconfont icon-shanchu"
                    @click="handleDel(scope.row, scope.index)"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/修改 公告分类 -->
    <el-dialog v-ops:width="450" :close-on-click-modal="false" :title="noticeTitle" :visible.sync="showDialog">
      <el-form ref="noticeClassifyForm" :rules="noticeClassifyRules" :model="noticeClassifyForm" label-width="120px">
        <el-form-item label="公告分类名称" prop="name">
          <el-input type="text" maxlength="30" placeholder="请输入公告分类名称" v-model="noticeClassifyForm.name"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelNoticeClassifyForm"> 取消</el-button>
        <el-button type="primary" @click="saveNoticeClassifyForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增/修改 公告信息-->
    <el-dialog class="test-dialog" width="700" top="11vh" :close-on-click-modal="false" :title="title"
      :visible.sync="showAddOrEditPanel">
      <!-- 内容区域 -->
      <div class="notice-box">
        <el-form style="width: 99%; height: 165px" :model="noticeFromInfo" :rules="noticeFromRule" ref="noticeFrom"
          label-width="120px" label-position="right" label-suffix=" ：">
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="公告标题" prop="title">
                <el-input v-model="noticeFromInfo.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="所属分类" prop="categoryId">
                <!-- <soc-select v-model='pnForm.categoryId' :attrOption="{label: 'label', value: 'value'}"
                  :options='pnTypeOptions' style="width: 210px;">
                </soc-select> -->
                <!-- disabled -->
                <el-select v-model="noticeFromInfo.categoryId" placeholder="请选择所属分类" style="width: 100%">
                  <el-option v-for="item in noticeClassifyArr" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="发布人" prop="issuer">
                <!-- <el-input v-model="noticeFromInfo.publisher"></el-input> -->

                <el-input v-model="noticeFromInfo.issuer" placeholder="请选择发布人员" clearable></el-input>
                <img style="
                    cursor: pointer;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                  " src="@src/common/assets/images/icon/more.png" @click="openChoosePeople" alt="" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="可见范围" prop="visibleRangeStr">
                <el-input v-model="noticeFromInfo.visibleRangeStr" placeholder="请选择可见范围" clearable></el-input>
                <img style="
                    cursor: pointer;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                  " src="@src/common/assets/images/icon/more.png" @click="openChooseVisibleRange" alt="" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item label="公告内容" prop="content">
                <!-- <Editor
                  v-model="noticeFromInfo.content"
                  :min-height="192"
                  style="color: blue"
                /> -->
                <CustomEditor ref="customEditor" v-model="noticeFromInfo.content" @editorTransfer="editorTransfer"
                  :min-height="300" style="color: blue" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item label="附件">
                <!-- 多文件上传 -->
                <el-upload ref="fileUpload" action="/common/file/batchFileload.json" list-type="fileList"
                  accept="doc,docx,xls,xlsx,ppt,pptx,txt,pdf,svg,psd" name="files" :on-success="onSuccessFile"
                  :on-remove="handleRemove">
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <div slot="tip" style="color: #f56c6c">
                    只能上传文件doc,docx,xls,xlsx,ppt,pptx,txt,pdf,svg,psd，且不超过5MB!
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 按钮区域 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAddOrEditPanel" type="info" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSaveAddOrEditPanel">
          保存
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSavePublishPanel">
          {{ subLoading ? "提交中" : "保存并发布" }}
        </el-button>
      </div>
      >
    </el-dialog>
    <!-- 公告详情信息 -->
    <el-dialog class="test-dialog" width="700" top="11vh" :close-on-click-modal="false" title="公告详情"
      :visible.sync="showDetailPanel">
      <div style="max-height: 63vh; overflow-y: auto">
        <iframe id="detailFrame" frameBorder="0" marginHeight="0" marginWidth="0" style="
            position: relative;
            top: 0%;
            left: 5%;
            background-color: transparent;
            width: 90%;
            height: 60vh;
          " allowTransparency="true"></iframe>
      </div>
      <!-- 附件 -->
      <div class="attachment-name-box">附件：</div>
      <div class="attachment-content-box" v-if="attachmentNameArr.length > 0">
        <div v-for="(item, index) in attachmentNameArr" :key="index">
          {{ item }}
        </div>
      </div>
      <div v-else class="attachment-no-content-box">暂无附件</div>

      <div slot="footer">
        <el-button @click="handleCloseDetailPanel">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 人员选择弹框 -->
    <el-dialog title="发布人员选择" :append-to-body="true" :visible.sync="dialogPeople" width="50%" class="choose-container">
      <div style="height: 550px;">
        <ioc-table ref="personTable" :data="personData" :option="personOption" :page="personPage"
          @size-change="personChangeSize" @current-change="currentChange" @search-change="searchList"
          @search-reset="personReset" @radio-change="personRadio">
          <!-- @selection-change="handlePersonSelectionChange" -->
          <template slot="status" slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: #00e8bb">{{
              onJobFormatter(scope.row)
            }}</span>
            <span v-if="scope.row.status === 2">{{
              onJobFormatter(scope.row)
            }}</span>
            <span v-if="scope.row.status === 4" style="color: yellow">{{
              onJobFormatter(scope.row)
            }}</span>
          </template>
        </ioc-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelChoose">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </span>
    </el-dialog>

    <!-- 可见范围弹窗 -->
    <el-dialog title="可见范围选择" :append-to-body="true" :visible.sync="dialogRange" width="55%" class="choose-container">
      <div class="range-box">
        <div class="left-box">
          <div class="content-box">
            <!-- <h3 class="title-box">人员部门</h3> -->
            <!-- <div
              v-for="(item, index) in rangeArr"
              :key="index"
              :class="[
                index != rangeArr.length - 1
                  ? 'content-border-item'
                  : 'content-item',
                item.selected ? 'content-selected-item' : '',
              ]"
              @click="selectedRangeClassifyItem(item)"
            >
              <div>{{ item.label }}</div>
            </div> -->
            <el-scrollbar class="scroll-bar" style="width: 100%;">
              <el-tree ref="tree" class="tree-content" :data="treeData" node-key="id"
                :default-expanded-keys="expandedKeys" default-expand-all :props="treeProps" :highlight-current="true"
                :filter-node-method="filterNode" @node-click="nodeClick">
                <template slot-scope="{ node }">
                  <element-tree-line :node="node" :showLabelLine="true" :indent="16" class="tree-line">
                    <span class="custom-tree-node">
                      <span class="tree-label" :title="node.label">
                        {{ node.label }}</span>
                    </span>
                  </element-tree-line>
                </template>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
        <div class="right-box">
          <ioc-table ref="rangeTable" :data="rangePersonData" :option="rangeOption" :page="rangePage"
            @size-change="rangeChangeSize" @current-change="rangeCurrentChange" @search-change="rangeSearchList"
            @search-reset="rangeReset">
            <!-- @row-click="rowClick" -->
            <template slot="onJob" slot-scope="scope">
              <span v-if="scope.row.onJob === 1" style="color: #00e8bb">{{
                onJobFormatter(scope.row)
              }}</span>
              <span v-if="scope.row.onJob === 2">{{
                onJobFormatter(scope.row)
              }}</span>
              <span v-if="scope.row.onJob === 4" style="color: yellow">{{
                onJobFormatter(scope.row)
              }}</span>
            </template>
          </ioc-table>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelRangeChoose">取消</el-button>
        <el-button type="primary" @click="confirmRangeChoose">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import echarts from "echarts";
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import ElementTreeLine from "element-tree-line";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/parkNotice";
import { personOption } from "../config/personTable";
import { rangeOption } from "../config/rangeTable";
import Editor from "../components/editor/index";
import CustomEditor from "../components/editor/customEditor.vue";
export default {
  components: {
    // iocFileUpload,
    ElementTreeLine,
    CustomEditor,
  },
  data() {
    return {
      imgUrl: require("../img/add.png"),
      editImgUrl: require("../img/edit.png"),
      deleteImgUrl: require("../img/delete.png"),
      // 公告分类 信息
      selectedNoticeClassify: -1,
      noticeClassifyArr: [],
      noticeTitle: "",
      showDialog: false,
      noticeClassifyForm: {
        id: -1,
        name: "",
      },
      noticeClassifyRules: {
        name: [
          {
            required: true,
            message: "请输入公告分类名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      surveyItemArr: [
        { label: "单选", value: 1 },
        { label: "多选", value: 2 },
        { label: "文本框", value: 3 },
      ],
      form: {},
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      itemTableData: [
        {
          title: "",
          description: "",
          type: 1,
        },
      ],
      searchParams: {},
      // 选择的NoticeId
      checkedNoticeIds: [],
      // 详情
      showDetailPanel: false,
      attachmentNameArr: [],
      // 新增/修改表格
      subLoading: false,
      title: "",
      showAddOrEditPanel: false,
      noticeFromInfo: {
        id: -1,
        categoryId: "",
        title: "",
        issuer: "",
        // 可见范围
        deptCodes: [],
        visibleRanges: [],
        visibleRangeStr: "",
        noticeUsers: "",
        content: "",
        annexList: [], // 附件
        status: 1,
      },
      noticeFromRule: {
        title: [{ required: true, message: "请输入公告标题", trigger: ['blur', 'change'] }],
        categoryId: [
          { required: true, message: "请选择公告分类", trigger: ['blur', 'change'] },
        ],
        issuer: [{ required: true, message: "请输入发布人", trigger: ['blur', 'change'] }],
        visibleRangeStr: [
          { required: true, message: "请选择可见范围", trigger: ['blur', 'change'] },
        ],
        content: [
          { required: true, message: "请输入公告内容", trigger: ['blur', 'change'] },
        ],
      },
      // 文件上传
      fileList: [],
      // 下拉选项信息
      noticeStatusOptions: [
        {
          value: 1,
          label: "未发布",
        },
        {
          value: 2,
          label: "已发布",
        },
      ],
      participantOptions: [],
      surveyItemOptions: [],
      optionItemOptions: [],

      // 参与人员
      checkPeopleInfo: null,
      personSearch: {
        pageNum: 1,
        total: 10,
        nickName: "",
      },
      dialogPeople: false,
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      personData: [],
      personOption: personOption(),

      // 可见范围
      checkNode: {},
      treeData: [],
      // 展开的节点id
      expandedKeys: [],
      treeProps: {
        children: "children",
        label: "name",
        id: "deptCode",
        isLeaf: "isLeaf",
      },
      rangeArr: [],
      checkRangeInfo: null,
      rangeSearch: {},
      dialogRange: false,
      rangePage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      rangeData: [],
      rangePersonData: [],
      rangeOption: rangeOption(),
    };
  },
  mounted() {
    // 获取公告分类数据
    this.initNoticeClassifyList();

    // 获取人员信息
    this.getPersonList();
  },
  beforeDestroy() {
    // window.onresize = null;
  },
  methods: {
    editorTransfer(data) {
      this.noticeFromInfo.content = data
    },
    // 初始化 公告 分类”数据
    initNoticeClassifyList() {
      // this.noticeClassifyArr = [
      //   { label: "工作通知", selected: true, id: "001" },
      //   { label: "放假通知", selected: false, id: "002" },
      //   { label: "行政通知", selected: false, id: "003" },
      // ];
      this.$fetch(api.noticeClassify.queryNoticeCategoryList, {}).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          if (response.returnObj.length > 0) {
            this.noticeClassifyArr = response.returnObj.map((item, index) => {
              let newItem = {
                label: item.name,
                selected: index == 0 ? true : false,
                id: item.id,
                disabled: false,
                ...item,
              };
              return newItem;
            });
            console.log("--this.noticeClassifyArr:--", this.noticeClassifyArr);
            this.selectedNoticeClassify = this.noticeClassifyArr[0].id;
            console.log("--默认选择的分类id:--", this.selectedNoticeClassify);
            // 获取分类下的公告 信息
            this.getNoticeList();
          } else {
            this.noticeClassifyArr = [];
          }
        }
      );
    },
    // 添加公告分类
    addNoticeClassify() {
      this.noticeTitle = "新增公告分类";
      this.noticeClassifyForm.id = undefined;
      this.showDialog = true;
    },
    // 修改公告分类
    editNoticeClassify(pItem) {
      console.log("---修改公告分类--index:--", pItem);
      this.noticeTitle = "修改公告分类";
      this.noticeClassifyForm = pItem;
      this.showDialog = true;
    },
    // 删除公告分类
    deleteNoticeClassify(pItem) {
      console.log("---删除公告分类--pItem:--", pItem);
      //
      this.$confirm("您确定删除该公告分类信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.noticeClassify.deleteNoticeCategory, {
          id: pItem.id,
        }).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.initNoticeClassifyList();
        });
      });
    },
    /** 改变条目状态 */
    selectedNoticeClassifyItem(pItem) {
      this.noticeClassifyArr.forEach((item) => {
        if (pItem.id == item.id) {
          item.selected = true;
          this.selectedNoticeClassify = item.id;
        } else {
          item.selected = false;
        }
        console.log(
          "----this.selectedNoticeClassify:---",
          this.selectedNoticeClassify
        );
      });
      this.getNoticeList();
      // 模拟数据使用
      // this.getList();
    },

    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 获取园区公告列表
    getNoticeList() {
      const params = {};
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;

      params.status = this.searchParams.status;
      params.title = this.searchParams.title;
      params.categoryId = this.selectedNoticeClassify;

      params.startTime = this.searchParams.startTime
        ? Dates.format(this.searchParams.startTime)
        : "";
      params.endTime = this.searchParams.endTime
        ? Dates.format(this.searchParams.endTime)
        : "";

      this.$fetch(api.notice.queryNoticeList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },
    // TODO获取列表
    getList() {
      this.tableData = [
        {
          title: "工作通知一",
          publisher: "admin",
          visibleRange: "全部人员",
          read: 100,
          unread: 50,
          status: 0,
          createTime: "2023-01-30T10:15:00.000+0800",
          id: "001",
        },
        {
          title: "工作通知二",
          publisher: "admin",
          visibleRange: "信息部",
          read: 50,
          unread: 20,
          status: 1,
          createTime: "2023-01-30T01:01:00.000+0800",
          id: "002",
        },
      ];
      this.page.total = this.tableData.length;
    },
    // 详情操作
    handleView(row, index) {
      console.log("--公告详情--row:--", row);
      this.attachmentNameArr = [];
      let fileArr = row.annexList;
      if (fileArr.length > 0) {
        this.attachmentNameArr = fileArr.map((item) => {
          return item.annexName;
        });
      } else {
        this.attachmentNameArr = [];
      }
      this.showDetailPanel = true;
      let content = row.content;
      // 模拟公告详情数据
      this.$nextTick(() => {
        let detailFrame = document.getElementById("detailFrame");
        detailFrame.contentWindow.document.body.innerHTML = content;
      });
    },
    //关闭详情
    handleCloseDetailPanel() {
      this.showDetailPanel = false;
    },
    closeDialog() { },

    // 查询按钮事件
    searchResult(param) {
      console.log("---查询--param:--", param);
      if (param.hasOwnProperty("createTime")) {
        if (param.createTime.length > 1) {
          this.searchParams.startTime = param.createTime[0];
          this.searchParams.endTime = param.createTime[1];
        }
      }

      this.searchParams.title = param.title;
      this.searchParams.status = param.status;
      console.log("---查询--this.searchParams:--", this.searchParams);
      this.page.currentPage = 1;
      this.getNoticeList();
    },
    // 重置按钮
    resetQuery() {
      console.log("---重置--this.searchParams:--", this.searchParams);
      this.searchParams.startTime = "";
      this.searchParams.endTime = "";
      this.searchParams.title = "";
      this.searchParams.status = "";
      this.getNoticeList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getNoticeList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getNoticeList();
    },
    handleSelectionChange(items) {
      console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedNoticeIds = [];
      } else {
        this.checkedNoticeIds = items.map((item) => {
          return item.id;
        });
      }
      console.log("----this.checkedNoticeIds:---", this.checkedNoticeIds);
    },
    // 新增操作
    handleAddNotice() {
      this.title = "新增公告";
      this.noticeFromInfo.id = undefined;

      // 禁掉公告分类的其他选项
      this.noticeClassifyArr.forEach((item) => {
        if (item.id == this.selectedNoticeClassify) {
          item.disabled = false;
        } else {
          item.disabled = true;
        }
      });
      if (this.$refs.customEditor) {
        this.$refs.customEditor.clearContent()
      }
      this.showAddOrEditPanel = true;
    },
    // 批量删除操作
    handelDelNotice() {
      console.log("批量删除操作");
      this.$confirm("您确定批量删除所选择的公告信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.notice.deleteNotice, this.checkedNoticeIds).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getNoticeList();
          }
        );
      });
    },
    // 编辑操作
    handleEditNotice(row, index) {
      this.getNoticeList()
      console.log("--handleEditNotice()--row:--", row);
      this.fileList = [];
      this.noticeFromInfo.annexList = [];
      console.log("-----fileList:-------", this.fileList);
      console.log("-----annexList:-------", this.noticeFromInfo.annexList);

      this.noticeFromInfo = row;
      this.noticeFromInfo.visibleRangeStr = row.visibleRange;
      console.log("-----deptCodes:-------", this.noticeFromInfo.deptCodes);
      console.log("--visibleRanges:-", this.noticeFromInfo.visibleRanges);
      this.noticeFromInfo.content = row.content
      this.title = "修改公告";
      this.showAddOrEditPanel = true;
      this.$nextTick(() => {
        this.$refs.customEditor.inputContent(row.content)
      })
    },
    // 发布操作
    handlePublish(row) {
      console.log("发布操作");
      this.$confirm("您确定发布该公告信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.notice.publishNotice, {
          id: row.id,
        }).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "发布成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getNoticeList();
        });
      });
    },

    // 单个删除操作
    handleDel(row) {
      console.log("单个删除操作");

      this.$confirm("您确定删除该公告信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.notice.deleteNotice, [row.id]).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getNoticeList();
        });
      });
    },
    onSuccessFile(res, file, fileList) {
      console.log("--onSuccessFile()---fileList:--", fileList);
      let fileArr = [];
      this.fileList = fileList;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.success) {
          fileArr.push({
            annexId: this.fileList[i].response.returnObj[0].fileId,
            annexName: this.fileList[i].name,
          });
        }
      }
      console.log("--onSuccessFile()---fileArr:--", fileArr);
      this.noticeFromInfo.annexList = fileArr;
    },
    handleRemove(file, fileList) {
      console.log("--handleRemove()---fileList:--", fileList);
      let fileArr = [];
      this.fileList = fileList;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.success) {
          fileArr.push({
            annexId: this.fileList[i].response.returnObj[0].fileId,
            annexName: this.fileList[i].name,
          });
        }
      }
      console.log("--onSuccessFile()---fileArr:--", fileArr);
      this.noticeFromInfo.annexList = fileArr;
    },

    // 关闭新增/修改 弹窗
    handleCloseAddOrEditPanel() {
      // TODO处理from表单取消校验操作
      this.handleRestForm();
      // this.getNoticeList();
      this.showAddOrEditPanel = false;
    },
    // 保存新增/修改 弹窗
    handleSaveAddOrEditPanel() {
      console.log('表单数据', this.noticeFromInfo)
      // TODO处理from表单校验操作
      // 新增/修改成功后的操作
      this.$refs.noticeFrom.validate((valid) => {
        if (valid) {
          let params = { ...this.noticeFromInfo };
          params.categoryId = this.selectedNoticeClassify;
          params.status = 1;

          if (params.id) {
            // 修改
            this.$fetch(api.notice.updateNotice, params).then((response) => {
              if (!response.success) {
                this.$message.error(response.msgContent);
              } else {
                this.$message.success("修改成功！");
              }
              // 关闭弹窗
              this.showAddOrEditPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getNoticeList();
            });
          } else {
            // 新增
            this.$fetch(api.notice.addNotice, params).then((response) => {
              if (!response.success) {
                this.$message.error(response.msgContent);
              } else {
                this.$message.success("新增成功！");
              }
              // 关闭弹窗
              this.showAddOrEditPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getNoticeList();
            });
          }

          // 模拟关闭
          // this.showAddOrEditPanel = false;
        } else {
          return false;
        }
      });
    },
    // 保存并发布 新增/修改 弹窗
    handleSavePublishPanel() {
      // 新增/修改成功后的操作
      this.$refs.noticeFrom.validate((valid) => {
        if (valid) {
          let params = { ...this.noticeFromInfo };
          params.categoryId = this.selectedNoticeClassify;
          params.status = 2;

          if (params.id) {
            // 修改
            this.$fetch(api.notice.updateNotice, params).then((response) => {
              if (!response.success) {
                this.$message.error(response.msgContent);
              } else {
                this.$message.success("修改成功！");
              }
              // 关闭弹窗
              this.showAddOrEditPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getNoticeList();
            });
          } else {
            // 新增
            this.$fetch(api.notice.addNotice, params).then((response) => {
              if (!response.success) {
                this.$message.error(response.msgContent);
              } else {
                this.$message.success("新增成功！");
              }
              // 关闭弹窗
              this.showAddOrEditPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getNoticeList();
            });
          }

          // 模拟关闭
          // this.showAddOrEditPanel = false;
        } else {
          return false;
        }
      });
    },
    // 公告分类 相关操作
    cancelNoticeClassifyForm() {
      this.handleRestNoticeClassifyForm();
      this.initNoticeClassifyList();
      this.showDialog = false;
    },
    saveNoticeClassifyForm() {
      this.$refs.noticeClassifyForm.validate((valid) => {
        if (valid) {
          let params = { ...this.noticeClassifyForm };
          if (params.id) {
            // 修改
            this.$fetch(api.noticeClassify.updateNoticeCategory, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.msgContent);
                } else {
                  this.$message.success("修改成功！");
                }
                // 关闭弹窗
                this.showDialog = false;
                this.handleRestNoticeClassifyForm();
                // 刷新列表数据
                this.initNoticeClassifyList();
              }
            );
          } else {
            // 新增
            this.$fetch(api.noticeClassify.addNoticeCategory, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.msgContent);
                } else {
                  this.$message.success("新增成功！");
                }
                // 关闭弹窗
                this.showDialog = false;
                this.handleRestNoticeClassifyForm();
                // 刷新列表数据
                this.initNoticeClassifyList();
              }
            );
          }
          // 关闭弹窗
          this.showDialog = false;
        } else {
          return false;
        }
      });
    },
    // 重置表单操作
    handleRestForm() {
      this.noticeFromInfo.id = undefined;
      this.noticeFromInfo.categoryId = "";
      this.noticeFromInfo.title = "";
      this.noticeFromInfo.issuer = "";
      // 可见范围
      this.noticeFromInfo.deptCodes = [];
      this.noticeFromInfo.visibleRanges = [];
      this.noticeFromInfo.visibleRangeStr = "";
      this.noticeFromInfo.content = "";
      this.noticeFromInfo.annexList = []; // 附件
      this.noticeFromInfo.status = 1;
      // 清空文件组件内容
      this.$refs.fileUpload.clearFiles();
      this.fileList = [];
      this.$refs["noticeFrom"].clearValidate();
    },
    handleRestNoticeClassifyForm() {
      this.noticeClassifyForm.name = "";
      this.$refs["noticeClassifyForm"].clearValidate();
    },
    // 获取参与人员信息
    getPersonList() {
      const params = {};
      params.pageNo = this.personPage.pageNum;
      params.pageSize = this.personPage.pageSize;
      params.nickName = this.personSearch.nickName;
      params.containOwnFlag = '1';
      // params.accountType = "3";
      this.$fetch(api.notice.queryPersonnelList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }

        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
        console.log("---人员列表信息:--", this.personData);
      });
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.deptCode;
          entity.name = item.deptName;
          entity.desc = item.desc;
          entity.parentCode = item.parentCode;
          entity.parentName = item.parentName;
          entity.isLeaf = !item.hasLeaf || !item.children;
          if (item.children) {
            entity.children = self.menusDataPro(item.children);
          }
          result.push(entity);
        });
        return result;
      }
    },
    //获取区域列表
    getDeptTree() {
      const self = this;
      this.$fetch(api.notice.queryDeptTree, { type: 1 }).then((response) => {
        if (!response.returnObj.length) {
          this.$message.error(response.msgContent);
          return;
        }
        const result = self.menusDataPro(response.returnObj);
        self.treeData = Object.freeze(result);
        console.log("--treeData:--", self.treeData);
        self.nodeClick(self.treeData[0]);
        self.$nextTick(() => {
          self.$refs.tree.setCurrentKey(self.treeData[0]);
        });
      });
    },
    // 单击节点时
    nodeClick(data) {
      this.checkNode = { ...data };
      this.checkRangeInfo = this.checkNode;
      this.rangePage.pageNum = 1;
      this.getPersonDataByDeptCode();
    },
    // 查询部门下得人员信息
    getPersonDataByDeptCode() {
      let param = {
        pageNum: this.rangePage.pageNum,
        pageSize: this.rangePage.pageSize,
        deptCode: this.checkNode.id,
      };
      this.$fetch(api.notice.queryPersonnelListByDeptCode, param).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.rangePersonData = response.returnObj.list;
        }
      );
    },
    // 选择发布人员相关
    openChoosePeople() {
      console.log("----选择发布人员的弹窗---");
      this.dialogPeople = true;
    },
    personChangeSize(val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPersonList();
    },
    currentChange(val) {
      this.personPage.pageNum = val;
      this.getPersonList();
    },
    searchList(param) {
      this.personSearch = Object.assign(param);
      this.personPage.pageNum = 1;
      this.getPersonList();
    },
    personReset() {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = 10;
      this.personSearch.nickName = "";
      this.getPersonList();
    },
    personRadio(item) {
      this.checkPeopleInfo = item;
    },
    handlePersonSelectionChange(items) {
      if (!items || !items.length) {
        this.checkPeopleInfo = [];
      } else {
        this.checkPeopleInfo = items.map((item) => {
          let newItem = {
            label: item.nickName,
            value: item.accountNumber,
          };
          return newItem;
        });
      }
    },
    // 人员取消
    cancelChoose() {
      this.dialogPeople = false;
      this.checkPeopleInfo = null;
      this.$refs.personTable.templateRadio = "";
    },
    // 人员确定
    confirmChoose() {
      if (!this.checkPeopleInfo) {
        this.$message.warning("请选择发布人");
        return;
      }
      console.log("--this.checkPeopleInfo:--", this.checkPeopleInfo);
      this.noticeFromInfo.issuer = this.checkPeopleInfo.nickName; // 人员姓名
      this.cancelChoose();
    },
    // 选择可见范围相关
    openChooseVisibleRange() {
      console.log("----选择可见范围相关--");
      this.dialogRange = true;
      // 获取部门人员信息
      this.getDeptTree();
    },
    rangeChangeSize(val) {
      this.rangePage.pageNum = 1;
      this.rangePage.pageSize = val;
      this.getPersonDataByDeptCode();
    },
    rangeCurrentChange(val) {
      this.rangePage.pageNum = val;
      this.getPersonDataByDeptCode();
    },
    rangeSearchList(param) {
      this.rangeSearch = Object.assign(param);
      this.rangePage.pageNum = 1;
      this.getPersonDataByDeptCode();
    },
    rangeReset() {
      this.getPersonDataByDeptCode();
    },
    // rowClick(item) {
    //   if (item.hasOwnProperty("children")) {
    //     this.$message.error("请选择部门下的人员信息");
    //   } else {
    //     this.$message.success("人员信息选择成功");
    //     this.checkRangeInfo = item;
    //   }
    // },
    // handleRangeSelectionChange(rItems) {
    //   console.log("--rItems:---", rItems);
    // },
    cancelRangeChoose() {
      this.dialogRange = false;
      this.checkRangeInfo = null;
      // this.$refs.rangeTable.templateRadio = "";
    },
    confirmRangeChoose() {
      if (!this.checkRangeInfo) {
        this.$message.warning("请选择部门信息");
        return;
      }
      console.log("--this.checkRangeInfo:--", this.checkRangeInfo);
      this.noticeFromInfo.deptCodes = [this.checkRangeInfo.id];
      this.noticeFromInfo.visibleRanges = [this.checkRangeInfo.name];
      this.noticeFromInfo.visibleRangeStr = this.checkRangeInfo.name;
      console.log("--visibleRanges:--", this.noticeFromInfo.visibleRanges);
      console.log("--deptCodes:--", this.noticeFromInfo.deptCodes);
      console.log("--this.noticeFromInfo:--", this.noticeFromInfo);
      // this.quesFromInfo.questionnaireQuestionList = [this.checkQuestionInfo.id]; //问题Id
      // this.quesFromInfo.questionnaireQuestionListStr =
      //   this.checkQuestionInfo.title; // 调查项名称
      this.cancelRangeChoose();
    },
    onJobFormatter(data) {
      switch (data.onJob * 1) {
        case 1:
          return "在职";
        case 2:
          return "离职";
        case 4:
          return "未知";
        default:
          return data.onJob;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.park-notice-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .left-box {
    width: 0px;
    flex: 1;
    height: 100%;
    @include set_theme_color(background-color, left-menu-bg-color);

    .title-box {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      // color: #fff;
      color: #000000;
      border-left-width: 3px;
      border-left-style: solid;
      padding-left: 10px;
      border-left-color: #407aee;
      position: relative;
    }

    .content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;

      .content-item {
        width: 95%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #407aee;
      }

      :active {
        background: #407aee;
      }

      .content-selected-item {
        background: #407aee;
      }

      .content-border-item {
        width: 95%;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid white;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #407aee;
      }

      :active {
        background: #407aee;
      }

      .content-selected-item {
        background: #407aee;
      }
    }
  }

  .access-record-container {
    width: 100%;
    height: 100%;

    .el-table__fixed-right-patch {
      display: none;
    }

    .el-dialog {

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
      }
    }
  }

  .right-box {
    width: 0px;
    flex: 4;
    height: 100%;
  }

  .survey-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 75vh;

    ::v-deep .el-form-item__content {
      width: 80%;
    }

    ::v-deep .el-select {
      width: 100%;
    }

    .survey-type-box {
      display: flex;

      ::v-deep .el-form-item__content {
        display: flex;
      }

      .desc {
        width: 155px;
        margin-left: 5px;
      }

      ::v-deep .el-select {
        width: 0px;
        flex: 1;
      }
    }

    ::v-deep .el-range-editor--small.el-input__inner {
      width: 95%;
    }
  }

  // ::v-deep .el-table thead th {
  //   // background-color: #343d55;
  //   @include set_theme_color(background-color, left-menu-bg-color);
  //   border: 0px solid;
  // }

  .notice-box {
    ::v-deep .el-form-item__content {
      width: 80%;
    }

    ::v-deep .el-select {
      width: 100%;
    }

    .ques-type-box {
      display: flex;

      ::v-deep .el-form-item__content {
        display: flex;
      }

      .desc {
        width: 155px;
        margin-left: 5px;
      }

      ::v-deep .el-select {
        width: 0px;
        flex: 1;
      }
    }

    ::v-deep .el-range-editor--small.el-input__inner {
      width: 95%;
    }

    ::v-deep .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 37vw;
    }
  }

  .test-dialog {
    ::v-deep .el-dialog {
      height: 88vh;
      overflow: hidden;
      right: 0;
      position: absolute;

      .el-dialog__body {
        position: absolute;
        left: 0;
        top: 54px;
        bottom: 7vh;
        right: 0;
        padding: 0;
        z-index: 1;
        overflow: hidden;
        overflow-y: auto;
        // 下边设置字体，我的需求是黑底白字
        color: #ffffff;
        line-height: 30px;
        padding: 0 15px;
      }

      .el-dialog__footer {
        position: absolute;
        bottom: 2vh;
        width: 100%;
        height: 40px;
      }

      .attachment-name-box {
        width: 90%;
        color: black;
        font-size: 16px;
        font-weight: 600;
        margin: 15px auto 0px auto;
        height: 26px;
      }

      .attachment-content-box {
        width: 90%;
        margin: 10px auto 0px auto;
        height: 4vh;
        max-height: 4vh;
        overflow-y: auto;
        color: black;
        font-size: 14px;
        font-weight: 300;
      }

      .attachment-no-content-box {
        width: 90%;
        margin: 10px auto 0px auto;
        height: 4vh;
        max-height: 4vh;
        overflow-y: auto;
        color: black;
        font-size: 14px;
        font-weight: 300;
      }
    }
  }
}
</style>

<style scoped>
/* @import "~@src/common/assets/style/mixin"; */
.range-box {
  width: 100%;
  height: 550px;
  display: flex;
  flex-direction: row;
  overflow-y: auto;
}

.left-box {
  width: 0px;
  flex: 1;
  height: 100%;
  background: #f3f3f3;
  /* @include set_theme_color(background-color, left-menu-bg-color); */
  margin-right: 10px;
  padding: 10px 15px;
}

.title-box {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  /* color: #fff; */
  color: #407aee;
  border-left-width: 3px;
  border-left-style: solid;
  padding-left: 10px;
  margin-left: 10px;
  border-left-color: #407aee;
  position: relative;
}

.content-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  height: 100%;
}

.right-box {
  width: 0px;
  flex: 4;
  height: 100%;
}

.scroll-bar {
  height: 100%;
  height: calc(100% - 100px);
}

.el-scrollbar__wrap .el-scrollbar__view {
  display: inline-block;
  min-width: 100%;
}
</style>
